<template>
  <div class="page-wrapper register-wrapper">
    <div class="register-content-wrapper content-wrapper">
    <div class="logo-wrapper">
      <van-image  fit="contain" width="200" height="100" :src="siteLogo" />
    </div>
      <van-form @submit="onSubmit">

        <van-field
          v-model="phone"
          name="phone"
          label="手机号"
          placeholder="手机号"
          :rules="[{ required: true,validator: phoneValidator}]"
        />

        <van-field
          v-model="sms"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          :rules="[{ required: true }]"
        >
          <template #button>
            <van-button @click="handleSmsSend" native-type="button" v-if="getCodeBtn" size="small" type="primary">发送验证码</van-button>
            <van-button disabled v-else  size="small" type="primary">重新发送&nbsp;&nbsp;&nbsp;&nbsp;{{count}}&nbsp;&nbsp;&nbsp;&nbsp;s</van-button>
          </template>
        </van-field>

        <van-field 
          v-model="password" 
          type="password" 
          label="密码" 
          placeholder="请输入密码"
          :rules="[{ required: true }]"/>

        <van-field 
          v-model="confirmPassword" 
          type="password" 
          label="确认密码" 
          placeholder="请确认密码"
          :rules="[{ required: true }]"/>

        <van-field name="checkboxGroup">
          <template #input>
              <van-checkbox name="1" v-model="checked" shape="square"><a style="color:#1989FA;margin-left:16px" @click="handleRegisterProtocolClick">注册协议</a></van-checkbox>
          </template>
        </van-field>

        <div style="margin: 16px;">
          <van-button :disabled="registerDisable" round block type="info" native-type="submit">
            注册
          </van-button>
        </div>
      </van-form>
    </div>

    <van-popup v-model="registerProtocolDialogVisible" closeable position="top" :style="{ height: '100%' }" >
      <div class="van-multi-ellipsis--l3">
        这是一段最多显示三行的文字，多余的内容会被省略
      </div>
    </van-popup>
    <!-- <van-dialog width="100%" v-model="registerProtocolDialogVisible" title="注册协议" show-cancel-button>
    </van-dialog> -->
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';
export default {
  computed:{
        siteLogo() {
          return require('@/assets/logo/logo.png')
      },
  },
   data() {
    return {
      registerDisable: false,
      count: 0,
      phone: '',
      password: '',
      confirmPassword: '',
      sms: '',
      checked: false,
      registerProtocolDialogVisible: false,
      getCodeBtn: true,
    };
  },
  methods: {
    phoneValidator(val) {
      const _this = this
      _this.noRegisterTip = ''
      return new Promise((resolve) => {
        const phonePattern = /[\d]{11}/g
        if (!val){
          resolve(false)
        }else if (!phonePattern.test(val)){
            Toast.fail('格式不正确');
            resolve(false)
        }else{
            _this.$get('/auth/phone/valid/' + val).then(res =>{
                if (res.data.success){
                    Toast.fail('该电话号码已经注册');
                    return resolve(false)
                }else {
                  return resolve()
                }
            })
        }
      });
    },
    handleSmsSend(){
      const TIME_COUNT = 60;
      const _this = this
      if(!_this.phone){
            Toast.fail({
              position: 'bottom',
              message: '请先填写手机号码'
            })
            return
      }
      if (!_this.timer) {
          _this.count = TIME_COUNT;
          _this.getCodeBtn = !_this.getCodeBtn
          _this.$post('/auth/sendSms',{ phone: _this.phone, type:'register'})
          .then(r =>{
                    console.log(r)
              if (r.data.success){
                 Toast.success({
                    position: 'bottom',
                    message: '验证码已发送 请注意查收'
                  })
              }else {
                   console.log('失败')
      
                  Toast.fail({
                    position: 'bottom',
                    message: '验证码发送出错 请重试'
                  })
              }
          })
          .catch(e =>{
            console.log('出错')
            console.log(e)
                 Toast.fail({
                    position: 'bottom',
                    message: '验证码发送出错 请重试'
                  })
          }).finally(()=>{

          });
          _this.timer = setInterval(() => {
              if (_this.count > 0 && _this.count <= TIME_COUNT) {
                  _this.count--;
              } else {
                  _this.getCodeBtn = !_this.getCodeBtn
                  clearInterval(_this.timer);
                  _this.timer = null;
              }
          }, 1000)
      }
    },
    onSubmit(values) {
      const _this = this
      if (_this.checked){
          _this.registerDisable = true
          _this.$post('/auth/register', {
            password: _this.password,
            confirmPassword: _this.confirmPassword,
            phone: _this.phone,
            validCode: _this.sms
          }).then(r =>{
            Dialog({
              title: '提示', 
              message: '注册成功,您将前往登录页面'
            }).then(() => {
              _this.$router.push('login')
            });
          }).catch(e =>{
          }).finally(()=>{
              _this.registerDisable = false
          });
      }else {
          Toast.fail({
            position: 'bottom',
            message: '请阅读并确认注册协议'
          })
      }
    },
    handleRegisterProtocolClick(){
      console.log('查看注册协议')
      this.registerProtocolDialogVisible = true
    },
  },
};
</script>

<style lang="scss">
.logo-wrapper{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register-content-wrapper{
  margin-top: 20px;
}
</style>
